import React, { useEffect, useState, useRef, useMemo } from "react";
import TableCstmPs from "../../../TableCstmPs/TableCstmPs";
import { getLastWeeks, getWeekLabel, getWeekNumber } from "../../../../utils/dateUtils";
import "./StudentDebts.scss";
import InputAnimated from "../../../inputAnimated/inputAnimated";
import Select from "../../../select/select";
import Tooltip from "../../../Tooltip/Tooltip";
import { compressDays, formatPhone, formatTime, paymentHistoryFormat } from "../../../../utils/format";
import { useNavigate } from "react-router-dom";
import { GetAllPaymentInfoByStudent, GetStudentsWithDebts } from "../../../../utils/Apis/receptionApis";
import SidePanel from "../../../SidePanel/SidePanel";
import { getWeeksRange } from "../../../../utils/dateUtils";
import PaymentHistory from "../PaymentReceipt/PaymentHistory/PaymentHistory";
import { GetAllTeacherClassesByEmployeeIdForDebts, GetAllTeachersBySubsidiaryOrInchargeReceptionist } from "../../../../utils/Apis/principalApis";
import InputAutoComplete from "../../../autocomplete/autocomplete";
import { getLocalDateObjectFromInput, getLocalDateTimeString } from "../../../../utils/dateTimeZone";
import { ClassNames } from "@emotion/react";
import PaymentHistoryLegends from "../../../paymentHisotryLegends/PaymentHistoryLegends";
import RePrintReceipt from "../PaymentReceipt/PaymentConfirm/RePrintReceipt/RePrintReceipt";
import Button from "../../../button/button";
import StudentObservation from "../../components/StudentObservation/StudentObservation";
import Alert from "../../../alert/Alert";
import Autocomplete from "../../../../DesignSystem/Molecules/Autocomplete/Autocomplete";
import LoadingComponent from "../../../loading/LoadingComponent/loadingComponent";
const StudentDebts = ({ listSubsidiary, usr, specialDateList, exemptWeeks, onRedirectToPayment }) => {
  const navigate = useNavigate();
  // ──────────────────────────────────────────────
  //estados
  // ──────────────────────────────────────────────
  const [scopeFilter, setScopeFilter] = useState("");
  const [teacherFilter, setTeacherFilter] = useState("all");
  const [modeFilter, setModeFilter] = useState("all");
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [subsidiaryState, setSubsidiaryState] = useState([]);
  const [teacherListState, setTeacherListState] = useState([])
  const [employeeIdState, setEmployeeIdState] = useState('')
  const [teacherSelected, setTeacherSelected] = useState({})
  const [studentObservationState, setStudentObservationState] = useState('')
  const [studentIdState, setStudentIdState] = useState('')
  const [teacherObjectSelectedFormated, setTeacherObjectSelectedFormated] = useState({})
  const [specialDates, setSpecialDates] = useState([])
  const [specialDateVacation, setSpecialDateVacation] = useState(new Set())

  const [paymentHistoryDatatoShow, setPaymentHistoryDataToShow] = useState({})
  const [paymentPlanStudentSelected, setPaymentPlanStudentSelected] = useState({})
  const [studentSelectedId, setStudentSelectedId] = useState(null)
  const [studentSelectedName, setStudentSelectedName] = useState(null)
  const [studentSelectedSubsidiary, setStudentSelectedSubsidiary] = useState(null)
  const [loading, setLoading] = useState(false);
  const [loadingPaymentHistory, setLoadingPaymentHistory] = useState(false);


  const currentReceptionistId = "R1";
  const today = new Date();
  const currentWeek = getWeekNumber(today);
  //determinar las semanas que se mostraran en columnas 
  const weeks = getWeeksRange({ back: 5, forward: 1 });
  //
  const cacheTeacherList = useRef({}); // 🔄 Caché por plantel
  const cacheTeacherGroupsList = useRef({}); // 🔄 Caché por maestro (grupos)
  const [error, setError] = useState(null);
  //print receipt
  const [isOpenPrintReceipt, setIsOpenPrintReceipt] = useState(false)
  const [receiptResultData, setReceiptResultData] = useState({})
  ////Alert
  const [isVisibleAlert, setIsVisibleAlert] = useState(false);
  const [arrayAlerts, setArrayAlerts] = useState([])

  //
  useEffect(() => {
    // 1. Validamos si ya existe el elemento para evitar duplicados
    const yaExiste = listSubsidiary.some(item => item.value === 0);

    if (!yaExiste) {
      // 2. Creamos una nueva lista con el elemento al inicio y el resto después
      const nuevaLista = [{ value: 'mine', label: 'Mis Maestros' }, ...listSubsidiary];

      // 3. Actualizamos el estado (asumiendo que tienes un setListSubsidiary)
      setSubsidiaryState(nuevaLista);
    }
  }, [listSubsidiary]); // Se ejecutará cuando la lista original cambie

  useEffect(() => {
    setEmployeeIdState(usr.employee_id);

    const vacation = specialDates.flatMap(sd => sd.weeks);

    const vacationsWithoutDuplication = Array.from(
      new Map(
        vacation.map(item => [
          `${item.week}-${item.year}`, // 🔥 key única
          item
        ])
      ).values()
    );
    const vacationSet = new Set(
      vacationsWithoutDuplication.map(v => `${v.week}-${v.year}`)
    );


    setSpecialDateVacation(vacationSet);

  }, [specialDates]);

  useEffect(() => {
    if (!specialDateList) return;

    const weekRangeArray = []; // lo vamos a llenar para cada evento

    const rangeWeekNumbers = (start, end) => {
      let endMonth = end.getMonth();
      let endYear = end.getFullYear();
      let startWeek = getWeekNumber(start);
      let endWeek = getWeekNumber(new Date(endYear, endMonth, end.getDate() - 1));
      let startYear = startWeek.year;
      let daysBetween = (end - start) / (1000 * 60 * 60 * 24);

      weekRangeArray.length = 0;

      let i = startWeek.weekNumber;
      let year = startYear;

      while (true) {
        weekRangeArray.push({ week: i, year });

        if (i === endWeek.weekNumber && year === endYear) {
          break;
        }

        i++;
        if (i > 52) {
          i = 1;
          year++;
        }
      }
    };
    //Function to get de week number of a date
    function getWeekNumber(date) {
      const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      // Ajustar para que la semana inicie en lunes
      tempDate.setUTCDate(tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7));
      // Calcular el inicio del año
      const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
      // Calcular la diferencia en días y obtener la semana
      const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

      return { weekNumber, year: tempDate.getUTCFullYear() };
    }

    const specialWeeks = specialDateList.map(({ name, date_start, date_end }) => {
      const start = getLocalDateObjectFromInput(date_start.split('T')[0]); // solo fecha YYYY-MM-DD
      const end = getLocalDateObjectFromInput(date_end.split('T')[0]);
      rangeWeekNumbers(start, end);

      return {
        name,
        weeks: [...weekRangeArray] // copia para que no se sobrescriba
      };
    });
    setSpecialDates(specialWeeks)
  }, [specialDateList]);

  const exemptSet = new Set(
    exemptWeeks.map(v => `${v.week}-${v.year}`)
  );
  // ──────────────────────────────────────────────
  //Helpers
  // ──────────────────────────────────────────────
  const compareWeeks = (a, b) => {
    if (!a || !b) return 0; // o decide si quieres -1

    const [wa, ya] = a.split('-').map(Number);
    const [wb, yb] = b.split('-').map(Number);

    if (ya !== yb) return ya - yb;
    return wa - wb;
  };

  const calculateDebtWeeks = (student, weeks) => {
    let count = 0;
    weeks.forEach((w) => {
      const key = `${w.number}-${w.year}`;
      const weekData = student.weeksSummary?.[key];
      const percent = weekData?.percentPaid || 0;

      const isPast =
        w.year < currentWeek.year ||
        (w.year === currentWeek.year && w.number < currentWeek.week);

      if (!isPast) return;

      // ❌ antes de inicio
      if (student.startWeek && compareWeeks(key, student.startWeek) < 0) return;

      // ❌ pausas
      if (student.pauses?.some(p =>
        compareWeeks(key, p.start) >= 0 &&
        compareWeeks(key, p.end) <= 0
      )) return;
      // ❌ inactive
      if (student.inactiveWeeks?.some(p =>
        compareWeeks(key, p.start) >= 0 &&
        compareWeeks(key, p.end) <= 0
      )) return;

      // ❌ exentas
      if (exemptSet.has(key)) return;

      // ❌ pagada completa
      if (percent === 100) return;

      // ✅ parcial o sin pagar = cuenta
      count++;
    });

    return count;
  };

  const calculateTotalDebt = (student, weeks, classDays) => {
    let total = 0;
    weeks.forEach((w) => {
      const isPast =
        w.year < currentWeek.year ||
        (w.year === currentWeek.year && w.number < currentWeek.week);
      if (isPast) {
        const result = getWeekStatus(student, w, classDays);
        if (result.shouldAddToTotal) {
          total += result.amount;
        }
      }
    });

    return total;
  };

  // ──────────────────────────────────────────────
  //handlers
  // ──────────────────────────────────────────────
  const handleCloseSidePanel = () => {
    setIsSidePanelOpen(false);
    // setSelectedStudent(null);
  }

  const handleOpenSidePanel = (student) => {
    setLoadingPaymentHistory(true)
    setIsSidePanelOpen(true);
    handleStudentPaymentHistory(student)
  }

  const handleStudentPaymentHistory = async (student) => {
    try {
      const studentPaymentInfoResponse = await GetAllPaymentInfoByStudent(student.studentId);
      if (studentPaymentInfoResponse.status === 200) {
        const history = await paymentHistoryFormat(studentPaymentInfoResponse.response.receipt);
        setStudentSelectedName(studentPaymentInfoResponse.response.student_name)
        setStudentSelectedId(studentPaymentInfoResponse.response.student_id)
        if (studentPaymentInfoResponse.response.student_subsidiary.class_subsidiary_id) {
          setStudentSelectedSubsidiary(studentPaymentInfoResponse.response.student_subsidiary.class_subsidiary_id)
        } else {
          setStudentSelectedSubsidiary(null)
        }
        setStudentObservationState(student.observation)
        setStudentIdState(student.studentId)
        setPaymentPlanStudentSelected(studentPaymentInfoResponse.response.payment_plan)
        const smallStudent = await formatDataToShowPaymentHistory(student, history);
        setPaymentHistoryDataToShow(smallStudent)
        setLoadingPaymentHistory(false)
      } else if (studentPaymentInfoResponse.status === 201) {
        setLoadingPaymentHistory(false)
      }
    } catch (error) {
      console.error("Error obteniendo historial de pagos:", error);
    }
  }

  const formatDataToShowPaymentHistory = (studentSelected, paymentHistory = []) => {
    return {
      id_student_section: null,
      id_student: studentSelected.studentId,

      name: `${studentSelected.name}`,
      concepts_to_pay: {
        tuition: [],
        books: [],
        inscription: {}
      },

      id_class: null,
      inscription_date: null,

      paymentHistory,

      schoolarship: studentSelected.scholarship ?? {
        id: null,
        normal: null,
        prompt: null,
        late: null,
        enrollment: null
      },

      class_type: null,

      class_days: null,

      full_class_name: null,

      is_online: null
    };
  };

  // ──────────────────────────────────────────────
  // 🧠 LÓGICA DE PAGO
  // ──────────────────────────────────────────────
  // Devuelve el lunes de la semana (semana = lunes-domingo)
  function getStartDateOfWeek(week, year) {
    const first = new Date(year, 0, 1);
    const day = first.getDay() || 7; // domingo = 7
    const firstMonday = new Date(first);
    firstMonday.setDate(first.getDate() - day + 1); // primer lunes del año

    const monday = new Date(firstMonday);
    monday.setDate(firstMonday.getDate() + (week - 1) * 7);
    monday.setHours(0, 0, 0, 0);

    return monday;
  }
  // Obtiene la fecha concreta del día de clase dentro de la semana
  function getClassDateOfWeek(week, year, classDaysStr) {
    // classDaysStr puede ser "Lunes,Martes" o array ya parseado; acepta null -> lunes
    const daysOrder = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    let classDaysArr = [];
    if (!classDaysStr) {
      classDaysArr = ["Lunes"];
    } else if (Array.isArray(classDaysStr)) {
      classDaysArr = classDaysStr;
    } else if (typeof classDaysStr === "string") {
      classDaysArr = classDaysStr.split(",").map(d => d.trim()).filter(Boolean);
    }

    // Tomamos el primer día de la semana (el más temprano) si hay varios
    const classDayIndex = classDaysArr.length > 0
      ? Math.min(...classDaysArr.map(day => {
        const idx = daysOrder.indexOf(day);
        return idx === -1 ? 0 : idx;
      }))
      : 0; // 0 = Lunes

    const monday = getStartDateOfWeek(week, year);
    const classDate = new Date(monday);
    classDate.setDate(monday.getDate() + classDayIndex); // +0 lunes, +5 sabado, etc.
    classDate.setHours(0, 0, 0, 0);
    return classDate;
  }

  /**
* Devuelve "prompt" | "normal" | "late"
* targetWeek, targetYear -> semana que se está evaluando (numero semana, año)
* classDaysRaw -> "Lunes,Martes" o "Viernes" o array o null
*
* Reglas implementadas:
* - Domingo-only: pronto pago toda la semana (hasta domingo). Si hoy > domingo -> late.
* - Solo Mon/Tue/Wed (todos los días del alumno están dentro de L-M-Mi): pronto pago hasta mié,
*   luego normal (jueves), luego late (semana siguiente).
* - Si tiene días únicamente en Jue/Vie/Sáb o incluye Jue/Vie/Sáb: pronto pago hasta el último día de clase,
*   el día siguiente -> normal, y luego late.
* - Para casos mixtos no cubiertos explícitamente, mantenemos comportamiento conservador (tratamos como Mon-Wed).
*/
  // Determinar tipo de pago para PRESENCIAL
  function getPresentialPaymentType(targetWeek, targetYear, classDaysStr) {
    const daysOrder = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    // Convertir lista de días


    let classDays = [];
    if (!classDaysStr) classDays = ["Lunes"];
    else classDays = classDaysStr.split(",").map(d => d.trim()).filter(Boolean);

    const dayIndexes = classDays.map(d => daysOrder.indexOf(d)).filter(i => i >= 0);
    if (dayIndexes.length === 0) dayIndexes.push(0);

    const now = new Date(getLocalDateTimeString());
    // const now ='2025-12-11 16:39:51';
    const monday = getStartDateOfWeek(targetWeek, targetYear);

    // Semana siguiente → late
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    sunday.setHours(23, 59, 59, 999);

    if (now > sunday) return "late";

    const minDay = Math.min(...dayIndexes);
    const maxDay = Math.max(...dayIndexes);

    // A) Solo DOMINGO
    if (dayIndexes.length === 1 && dayIndexes[0] === 6) {
      if (now <= sunday) return "prompt";
      return "late";
    }

    // B) Solo jueves-viernes-sábado (1 o 2 días)
    const isThuFriSatOnly = dayIndexes.every(i => i >= 3 && i <= 5);
    if (isThuFriSatOnly) {
      const lastClassDay = new Date(monday);
      lastClassDay.setDate(monday.getDate() + maxDay);
      lastClassDay.setHours(23, 59, 59, 999);

      if (now <= lastClassDay) return "prompt";
      if (now <= sunday) return "normal";
      return "late";
    }

    // C) Solo lunes-martes-miércoles
    const isMonTueWedOnly = dayIndexes.every(i => i >= 0 && i <= 2);

    if (isMonTueWedOnly) {
      const wednesday = new Date(monday);
      wednesday.setDate(monday.getDate() + 2);
      wednesday.setHours(23, 59, 59, 999);
      if (now <= wednesday) return "prompt";
      if (now <= sunday) return "normal";
      return "late";
    }

    // D) Grupo normal → Prompt SOLO hasta miércoles
    const wednesday = new Date(monday);
    wednesday.setDate(monday.getDate() + 2);
    wednesday.setHours(23, 59, 59, 999);

    if (now <= wednesday) return "prompt";
    if (now <= sunday) return "normal";
    return "late";
  }

  const resolveWeekPaymentStatus = ({
    student,
    weekObj,
    classDays,
    percent,
    amount
  }) => {

    const paymentPlan = student.paymentPlan;

    // =========================================================
    // Fecha actual
    // =========================================================
    const now = new Date();

    // =========================================================
    // Detectar si es pasada / actual / futura
    // =========================================================
    const isPast =
      weekObj.year < currentWeek.year ||
      (weekObj.year === currentWeek.year &&
        weekObj.number < currentWeek.week);

    const isCurrent =
      weekObj.year === currentWeek.year &&
      weekObj.number === currentWeek.week;

    // =========================================================
    // Obtener fecha REAL de clase
    // (usa tu helper del backend)
    // =========================================================
    const classDate = getClassDateOfWeek(
      weekObj.number,
      weekObj.year,
      classDays
    );

    // =========================================================
    // DEADLINE
    // =========================================================
    const promptDeadline = new Date(classDate);
    promptDeadline.setDate(promptDeadline.getDate() + 9);

    // =========================================================
    // Tipo de pago
    // =========================================================
    let paymentType = "normal";

    if (paymentPlan.is_online) {

      if (now <= promptDeadline) {
        paymentType = "prompt";
      } else {
        paymentType = "late";
      }

    } else {

      // presencial
      paymentType = getPresentialPaymentType(
        weekObj.number,
        weekObj.year,
        classDays
      );
    }

    // =========================================================
    // Monto total de esa semana
    // =========================================================
    let totalAmount = paymentPlan.normal;

    if (paymentType === "prompt") {
      totalAmount = paymentPlan.early;
    }

    if (paymentType === "late") {
      totalAmount = paymentPlan.late;
    }

    // =========================================================
    // Pagado actualmente
    // =========================================================
    function roundToNearestHalf(value) {
      return Math.round(value * 2) / 2;
    }
    const paidAmount = amount
    const remaining = roundToNearestHalf(totalAmount - paidAmount);


    return {
      paymentType,
      totalAmount,
      paidAmount,
      remaining,
      isPast,
      isCurrent
    };
  };

  const getWeekStatus = (student, weekObj, classDays) => {

    const key = `${weekObj.number}-${weekObj.year}`;
    const weekData = student.weeksSummary?.[key];
    const percent = weekData?.percentPaid || 0;
    const amount = weekData?.amount || 0;

    // 🔹 Antes de inicio
    if (
      student.startWeek &&
      compareWeeks(key, student.startWeek) < 0
    ) {
      return {
        label: "N/A",
        type: "na",
        amount: 0,
        shouldAddToTotal: false
      };
    }

    // 🔹 Pausas
    if (
      student.pauses?.some(
        p =>
          compareWeeks(key, p.start) >= 0 &&
          compareWeeks(key, p.end) <= 0
      )
    ) {
      return {
        label: "PAUSA",
        type: "paused",
        amount: 0,
        shouldAddToTotal: false
      };
    }

    // 🔹 INACTIVE
    if (
      student.inactiveWeeks?.some(
        p =>
          compareWeeks(key, p.start) >= 0 &&
          compareWeeks(key, p.end) <= 0
      )
    ) {
      return {
        label: "BAJA",
        type: "inactive",
        amount: 0,
        shouldAddToTotal: false
      };
    }

    // 🔹 Exenta
    if (exemptSet.has(key)) {
      return {
        label: "EXENTA",
        type: "exempt",
        amount: 0,
        shouldAddToTotal: false
      };
    }

    // ======================================================
    // 🔥 Resolver estado financiero
    // ======================================================

    const financial = resolveWeekPaymentStatus({
      student,
      weekObj,
      classDays,
      percent,
      amount
    });

    const {
      remaining,
      totalAmount,
      paymentType,
      isPast
    } = financial;

    // 🔹 Pagada completamente
    if (percent === 100) {
      return {
        label: "PAGADA",
        type: "paid",
        amount: 0,
        shouldAddToTotal: false
      };
    }

    // 🔹 Parcial
    if (percent > 0) {
      const value = Math.round(remaining);

      return {
        label: `RESTA $${value}`,
        type: isPast ? "late-partial" : "partial",
        amount: value,
        shouldAddToTotal: true
      };
    }

    // 🔹 Semana vencida
    if (isPast) {
      const value = Math.round(totalAmount);

      return {
        label: `$${value}`,
        type: paymentType === "late" ? "late" : "normal",
        amount: value,
        shouldAddToTotal: true
      };
    }
    // 🔹 Vacaciones
    if (specialDateVacation.has(key) && percent === 0) {
      const value = Math.round(totalAmount);

      return {
        label: `$${value}`,
        type: "vacation",
        amount: value,
        shouldAddToTotal: true
      };
    }


    // 🔹 Futuras
    // 🔹 Semana vencida
    if (!isPast) {
      const value = Math.round(totalAmount);

      return {
        label: `$${value}`,
        type: paymentType,
        amount: value,
        shouldAddToTotal: true
      };
    }

  };

  // ──────────────────────────────────────────────
  // 🔄 TRANSFORMACIÓN
  // ──────────────────────────────────────────────

  const applyScholarship = (amount, percent = 0) => {
    if (percent === 100) return 0;
    if (percent === 50) return amount * 0.5;
    return amount;
  };



  // ──────────────────────────────────────────────
  // 📊 COLUMNAS
  // ──────────────────────────────────────────────
  const staticColumns = [
    {
      header: "Alumno",
      accessor: "name",
      headerClassName: "tableCtype5 ",
      render: (value, student) => {
        const tooltipContent = (
          <div className="student-info-hover">
            {student.paymentPlan?.early && (
              <p>
                <strong>Plan:</strong>
                {" "}
                ${student.paymentPlan.early}
                {" / "}
                ${student.paymentPlan.normal}
                {" / "}
                ${student.paymentPlan.late}
              </p>
            )}

            {student.scholarship?.percent > 0 && (
              <p>
                <strong>Beca:</strong> {student.scholarship.percent}%
              </p>
            )}

            {student.observation && (
              <p>
                <strong>Observaciones:</strong> {student.observation}
              </p>
            )}
          </div>
        );

        return (
          <Tooltip
            showFlag
            text={tooltipContent}
            positionX="right"
            positionY="center"
          >
            <span
              className="student-link"
            >
              {value}
            </span>
          </Tooltip>
        );
      },
    },

    {
      header: "Teléfono",
      accessor: "phone",
      headerClassName: "c ",
      render: (value) => formatPhone(value),
      cellClassName: " align-center",

    },

    {
      header: "Último pago",
      accessor: "lastPayment",
      headerClassName: "tableCtype3 ",
      cellClassName: " align-center",

      render: (payment) => {
        if (!payment?.date) return "Sin pagos";

        return (
          <Tooltip
            showFlag
            text={`Folio: ${payment.receiptId}
            Fecha: ${payment.date}
            Monto: $${payment.amount}`}
            positionX="right"
            positionY="center"
          >
            {payment.date}
          </Tooltip>
        );
      },
    },
    {
      header: "#Sem",
      accessor: (student) => calculateDebtWeeks(student, weeks),
      cellClassName: " align-center",
    },
    {
      header: "Deuda total",
      accessor: (student) =>
        calculateTotalDebt(
          student,
          weeks,
          Array.isArray(student.scheduleDays)
            ? student.scheduleDays.join(", ")
            : ""
        ),

      render: (value) => `$${value}`,

      cellClassName: (value) =>
        (value > 0 ? "debt" : "") + " align-center tableCtype1",
    }
  ];

  const dynamicColumns = weeks.map((week) => {
    const key = `${week.number}-${week.year}`;

    const isCurrent =
      week.year === currentWeek.year &&
      Number(week.number) === Number(currentWeek.week);

    const isVacation = specialDateVacation.has(key);

    return {
      id: key,

      header: week.label,

      accessor: (student) =>
        getWeekStatus(student, week, Array.isArray(student.scheduleDays)
          ? student.scheduleDays.join(", ")
          : ""),

      render: (status) => status.label,

      headerClassName: "tableCtype1 " +
        (isCurrent
          ? "current-week-header"
          : isVacation
            ? "vacation-week-header"
            : ""),

      cellClassName: (status) => status.type + " align-center",
    };
  });
  // ──────────────────────────────────────────────
  useEffect(() => {
    const controller = new AbortController();
    const fetchTeacherData = async () => {
      setLoading(true);
      setError(null);

      try {
        // 🔍 Revisamos si ya tenemos el resultado en caché
        if (scopeFilter in cacheTeacherList.current) {
          const cachedData = cacheTeacherList.current[scopeFilter];
          setTeacherListState(cachedData);
          setLoading(false);
          return;
        }

        const isbyReceptionistInCharge = scopeFilter === "mine";

        const teacherListResponse =
          await GetAllTeachersBySubsidiaryOrInchargeReceptionist(
            employeeIdState,
            scopeFilter,
            isbyReceptionistInCharge
          );
        if (controller.signal.aborted) return;

        if (teacherListResponse.auth === false) {
          navigate("/login");
          return;
        }
        const formattedList = teacherListResponse.result.map((v) => ({
          employee_id: v.employee_id,
          name: v.name,
          contact: {
            email: v.email,
            phone: v.phone_number
          }
        }));

        // 🧠 Guardar en caché
        cacheTeacherList.current[scopeFilter] = formattedList;
        setTeacherListState(formattedList);
        setTeacherObjectSelectedFormated({})
        setLoading(false)

      } catch (err) {
        if (!controller.signal.aborted) {
          setError("Error al cargar los maestros");
          setLoading(false)
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    if (scopeFilter) {
      setTeacherSelected({})
      fetchTeacherData();

    }

    return () => {
      controller.abort(); // Cancelar solicitud si cambia `scopeFilter` o se desmonta
    };

  }, [scopeFilter])

  useEffect(() => {
    if (Object.keys(teacherSelected).length !== 0) {
      const employee_id = teacherSelected.employee_id
      const controller = new AbortController();

      const fetchTeacherGroups = async () => {
        setLoading(true);
        setError(null);

        try {
          if (employee_id in cacheTeacherGroupsList.current) {
            const cachedData = cacheTeacherGroupsList.current[employee_id];
            setTeacherObjectSelectedFormated(cachedData);
            setLoading(false);
            return;
          }
          const teacherGroupsResponse = await GetAllTeacherClassesByEmployeeIdForDebts(employee_id)
          if (teacherGroupsResponse.status === 200) {
            const formattedTeacher = teacherGroupsResponse.teacherClasses.reduce((acc, teacherClass) => {
              if (!acc.id) {
                acc.id = teacherClass.teacher.id;
                acc.name = teacherClass.teacher.name;
                acc.receptionist = teacherClass.teacher.receptionist_in_charge || null;
                acc.groups = [];
              }

              acc.groups.push({
                id: teacherClass.id,

                level: {
                  name: teacherClass.level?.name || "",
                  unit: teacherClass.level?.unitName || "",
                },

                subsidiary: {
                  id: teacherClass.subsidiary?.id || null,
                  name: teacherClass.subsidiary?.name || "",
                },

                schedule: {
                  days:
                    teacherClass.class_day?.map(day =>
                      day.name?.toLowerCase()
                    ) || [],

                  hours: {
                    start: teacherClass.time?.start || "",
                    end: teacherClass.time?.end || "",
                  },
                },

                isOnline: String(teacherClass.is_online || 0),

                students:
                  teacherClass.students?.map(student => {
                    const lastPayment = student.lastPayments?.[0] || null;

                    const weeksSummary = {};

                    student.lastPayments?.forEach(payment => {
                      payment.concepts?.forEach(concept => {
                        const week = concept.week?.week;
                        const year = concept.week?.year;

                        if (!week || !year) return;

                        const key = `${week}-${year}`;
                        const amount = concept.amount;
                        const percentPaid = Number(concept.week?.percent_paid || 0);

                        const isActive = concept.week?.paid_is_active === "1";

                        // Si ya estaba pagada al 100, NO la sobrescribas
                        if (weeksSummary[key] === 100) return;

                        // Solo guardar pagos activos
                        if (isActive) {
                          weeksSummary[key] = { percentPaid: percentPaid, amount: amount }
                        } else {
                          // Solo poner 0 si nunca existió un pago válido
                          if (!(key in weeksSummary)) {
                            weeksSummary[key] = { percentPaid: 0, amount: 0 };
                          }
                        }
                      });
                    });
                    // 🔥 AQUÍ VA startWeek
                    const weekKeys = Object.keys(weeksSummary);

                    let startWeek = "";

                    if (weekKeys.length > 0) {
                      const sortedWeeks = weekKeys
                        .map(key => {
                          const [week, year] = key.split("-").map(Number);

                          return { week, year };
                        })
                        .sort((a, b) => {
                          if (a.year !== b.year) return a.year - b.year;
                          return a.week - b.week;
                        });

                      const firstWeek = sortedWeeks[0];

                      let previousWeek = firstWeek.week;
                      let previousYear = firstWeek.year;

                      if (previousWeek <= 0) {
                        previousWeek = 52;
                        previousYear -= 1;
                      }

                      startWeek = `${previousWeek}-${previousYear}`;

                    } else {
                      const now = new Date();

                      const getISOWeek = (date) => {
                        const tempDate = new Date(date);
                        tempDate.setHours(0, 0, 0, 0);

                        tempDate.setDate(
                          tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7)
                        );

                        const week1 = new Date(tempDate.getFullYear(), 0, 4);

                        return (
                          1 +
                          Math.round(
                            ((tempDate - week1) / 86400000 -
                              3 +
                              ((week1.getDay() + 6) % 7)) /
                            7
                          )
                        );
                      };

                      const currentWeek = getISOWeek(now);
                      const currentYear = now.getFullYear();

                      startWeek = `${currentWeek}-${currentYear}`;
                    }
                    return {
                      studentId: student.student_id,

                      name: [
                        student.student_name,
                        student.student_middle_name,
                        student.student_last_name,
                      ]
                        .filter(Boolean)
                        .join(" "),

                      phone: student.student_phone_number || "",

                      status: "1",

                      weeksSummary,

                      lastPayment: lastPayment
                        ? {
                          receiptId: String(lastPayment.receipt_id),
                          date: lastPayment.receipt_date,
                          amount: lastPayment.total_paid,

                          weeksCovered:
                            lastPayment.concepts
                              ?.map(concept => {
                                const week = concept.week?.week;
                                const year = concept.week?.year;

                                if (!week || !year) return null;
                                return `${week}-${year}`;
                              })
                              .filter(Boolean) || [],
                        }
                        : null,

                      startWeek,
                      observation: student.student_observation || '',
                      pauses: student.pauses || [],
                      inactiveWeeks: student.inactiveWeeks || [],
                      paymentPlan: student.paymentPlan || null,
                      scholarship: student.scholaship

                    };
                  }) || [],
              });

              return acc;
            }, {});
            // 🧠 Guardar en caché
            cacheTeacherGroupsList.current[employee_id] = formattedTeacher;
            setTeacherObjectSelectedFormated(formattedTeacher)
            setLoading(false)


          } else {
            setTeacherObjectSelectedFormated({})
            setLoading(false)
          }
        } catch (err) {
          if (!controller.signal.aborted) {
            setError("Error al cargar los grupos del maestro");
          }
        } finally {
          if (!controller.signal.aborted) {
            setLoading(false);
          }
        }
      }
      fetchTeacherGroups()
    }
  }, [teacherSelected])

  const handleScopeFilter = async (value) => {
    setScopeFilter(value)
  }
  // Función para construir el nombre completo
  const getFullName = (teacher) => {
    return `${teacher.name}`;
  };

  const handleTeacherChange = (value) => {
    if (value === null) {
      setTeacherSelected({})
      return;
    }
    setTeacherSelected(value)


  }

  const dataToShow = useMemo(() => {
    if (!teacherObjectSelectedFormated?.groups) return null;

    return {
      teacherName: teacherObjectSelectedFormated.name,
      receptionist: teacherObjectSelectedFormated.receptionist,
      groups: teacherObjectSelectedFormated.groups
        .filter(group => {
          if (!modeFilter || modeFilter === "all") return true;
          return group.isOnline === modeFilter;
        })
        .map((group) => {
          const { start, end } = group.schedule.hours;
          return {
            group_id: group.id,
            scheduleLabel: `${compressDays(group.schedule.days)} ${formatTime(start.slice(0, 5))} - ${formatTime(end.slice(0, 5))}`,
            level: group.level.name,
            unit: group.level.unit,
            students: group.students.map(student => ({
              ...student,
              scheduleDays: group.schedule.days
            })),
            isOnline: group.isOnline
          };
        }),
    };
  }, [teacherObjectSelectedFormated, modeFilter]);
console.log(dataToShow)
  const handleClosePrintReceipt = () => {
    setIsOpenPrintReceipt(false);
  }

  const handleRedirectionToPaymentPage = () => {
    onRedirectToPayment({
      studentId: studentSelectedId,
      student: studentSelectedName,
      subsidiary: studentSelectedSubsidiary
    });
  };
  const showAlert = (type, message) => {
    const id = Math.floor(Math.random() * 100) + 1;
    const alertObj = { id, type, message };

    setArrayAlerts(oldArray => [alertObj, ...oldArray]);
    setIsVisibleAlert(true);
  };
  return (
    <>
      <div className="student-debts-container main-color">
        <div className="student-debts-c-header">
          <div className="header-title"><h1 className="title-1">Lista de adeudos</h1></div>
          <div className="filters">
            <Select
              options={subsidiaryState}
              onChange={(e) => handleScopeFilter(e.target.value)}
              placeholder={'Selecciona Sucursal / Mis maestros'}
              value={scopeFilter}
            />
            <Autocomplete
              options={teacherListState}// Pasa los objetos completos como opciones 
              getOptionLabel={(option) => getFullName(option)} // Controla cómo se muestra el texto en las opciones
              value={
                Object.keys(teacherSelected).length !== 0 ? teacherListState.find(t => t.employee_id === teacherSelected.employee_id) : null
              } // Aquí pasas el objeto completo
              onChange={(value) => handleTeacherChange(value)}
              placeholder={"Busca al maestro"}
              showOptionsOnFocus={false}
            />
            <Select
              options={[
                { value: "all", label: "Todas las modalidades" },
                { value: "1", label: "Online" },
                { value: "0", label: "Presencial" },
              ]}
              onChange={(e) => setModeFilter(e.target.value)}
              placeholder={'Modalidad'}
            />
          </div>
        </div>
        {
          loading ?
            <LoadingComponent text={'cargando...'} />
            :
            dataToShow ?
              <section key={dataToShow.teacherName} className="teacher-group">
                <h2 className="teacher-name main-color">{dataToShow.teacherName}</h2>

                {dataToShow.groups.map((group) => (
                  <div className="group-individual-section" key={group.id}>
                    <h3 className="schedule-label">{group.scheduleLabel}</h3>
                    <h3 className="teacher-group-level">Nivel: {group.level} Unidad: {group.unit}</h3>
                    <h3 className="teacher-group-level">Modalidad: {group.isOnline === '1' || group.isOnline === 1 ? 'Online' : 'Presencial'} </h3>
                    <span>Recepcionistas: </span>
                    {dataToShow.receptionist.length === 0 ? (
                      <strong>No cuenta con recepcionista encargado</strong>
                    ) : (
                      <div className="receptionist-list">
                        {dataToShow.receptionist.map((r) => (
                          <div key={r.id} className="receptionist-item">
                            <strong>{r.name}</strong>
                            <span>{r.contact.phoneNumber}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    <TableCstmPs
                      columns={[...staticColumns, ...dynamicColumns]}
                      data={group.students}
                      className="student-debts-table"
                      rowKey="studentId"
                      variant="modern"
                      layout={{
                        borderMode: "separate",
                        stickyHeader: true,
                      }}
                      styleOptions={{
                        hoverable: true,
                        rounded: true,
                        shadow: true,
                      }}
                      onRowDoubleClick={(student) => handleOpenSidePanel(student)}
                    />
                  </div>
                ))}
              </section>
              :
              Object.keys(teacherSelected).length !== 0 &&
              <section className='teacher-groups-txt'>
                No cuenta con grupos activos
              </section>
        }
        <SidePanel className="student-debts-sidepanel" open={isSidePanelOpen} onClose={handleCloseSidePanel}>
          {/* faltaria agregar informacion de alumno como observaciones modificables quizas mas datos de contacto  */}
          {paymentHistoryDatatoShow && (
            <>
              <h2 className="title-2">{studentSelectedName}</h2>
              <PaymentHistoryLegends />
              <Button className="student-debts-button-make-payment" onClick={handleRedirectionToPaymentPage} text={'Realizar pago'} />
              <StudentObservation observation={studentObservationState} student_id={studentIdState} showAlert={showAlert} />
              {
                loadingPaymentHistory ? <LoadingComponent text={'cargando...'} /> :
                  Object.keys(paymentHistoryDatatoShow).length !== 0 && paymentHistoryDatatoShow.paymentHistory.length !== 0 ?
                    <PaymentHistory className="student-debts-payment-history" setIsOpenPrintReceipt={setIsOpenPrintReceipt} setReceiptData={setReceiptResultData} student={paymentHistoryDatatoShow} paymentPlan={paymentPlanStudentSelected} showActions={false} />
                    :
                    <p>No cuenta con ningun pago</p>
              }
              {isOpenPrintReceipt && <RePrintReceipt isOpen={isOpenPrintReceipt} onClose={handleClosePrintReceipt} receiptData={receiptResultData} />}

            </>
          )}
        </SidePanel>
        <div className="divAlert">
          <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
        </div>
      </div>

    </>
  );
};

export default StudentDebts;
